<template>
    <div class="row m-0">
        <div class="col-12 p-0" v-for="(cover, indexParent) in state.coverFieldData" :key="indexParent">
            <div class="row m-0">
                <div class="col-lg-3 p-0 my-2" v-for="(coverField, indexChild) in cover" :key="indexChild" v-show="coverField.parameterName!='Allocation Percentage'">
                    <div class="form-group p-0 mx-0 my-1" v-if="(coverField.dataType=='String' || coverField.dataType=='Others')">
                        <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)">
                            <input
                                type="text" 
                                :placeholder="coverField.parameterName" 
                                :maxlength="checkMaxLength(coverField, coverCode)"
                                v-model="coverField.value"
                                onpaste="return false"
                                class="form-control"
                                :class="{ 'bgc-error-field': coverField.isMandatory && coverField.errorText!=='' }"
                                @blur="checkError(coverField, coverCode)"
                                v-on:keydown="validateInput(coverField,$event,coverCode)"
                            >
                        </float-label>
                        <span class="error-text"
                            v-if=" coverField.errorText!==''"
                        >{{ coverField.errorText}}</span> 
                    </div>
                    <div class="form-group p-0 mx-0 my-1" v-if="(coverField.dataType=='DropDown')">
                        <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)" v-if="coverField.parameterName!=='Geographical extension'">
                            <select
                                :placeholder="coverField.parameterName" 
                                v-model="coverField.value"
                                class="form-control"
                                :class="{ 'bgc-error-field': coverField.isMandatory && coverField.errorText!=='' }"
                                @blur="checkError(coverField, coverCode)">
                                <option disabled selected value="">{{coverField.parameterName}}</option>
                                <option v-for="cover in coverField.domainValues" :key="cover.code" :value="cover.code">{{ cover.name }}</option>
                            ></select>
                        </float-label>
                        <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)" v-if="coverField.parameterName=='Geographical extension'">
                            <select id="selectedListCountryType" class="form-control" name="selectedListCountryType" :placeholder="coverField.parameterName" 
                            :class="{ 'bgc-error-field': coverField.errorText!=='' || state.applyErrorFlag}" @change="selectDocumentType(coverField)" v-model="coverField.value" @blur="checkError(coverField, coverCode)">
                                <option value="" disabled selected>{{coverField.parameterName}}</option>
                                <option v-for="country in coverField.domainValues" :key="country.code" :value="country.code" :disabled="isDocSelected(country, coverField)">
                                    <label :for="'check'+country.code">{{country.name}}</label>
                                </option>
                            </select>
                        </float-label>
                        <span class="error-text"
                            v-if="coverField.errorText!==''"
                        >{{ coverField.errorText}}</span>
                        <span class="error-text"
                            v-if="state.applyErrorFlag && coverField.errorText==''"
                        >Geographical extension is required</span>
                        <div class="selected-list-types mt-3" v-if="coverField.parameterName=='Geographical extension'">
                            <div v-for="selectedCountry in  coverField.countrySelectedList" :key="selectedCountry.code" class="tag alert alert-dismissible">
                                <span class="selected-country-cover">{{selectedCountry.name}}</span>
                                <span class="close ml-2"
                                    data-dismiss="alert"
                                    @click="removeItem(selectedCountry, coverField)">
                                    <img src="@/assets/images/close-icon.png" width="20" alt="X">
                                </span>
                            </div>
                        </div> 
                    </div>
                    <div class="form-group p-0 mx-0 my-1" v-if="coverField.dataType=='Numeric' && coverField.parameterName!='Allocation Percentage'">
                        <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)">
                            <input 
                                type="text" 
                                :placeholder="coverField.parameterName"
                                :maxlength="checkMaxLength(coverField, coverCode)"
                                onpaste="return false" 
                                v-model="coverField.value"
                                class="form-control"
                                :class="{ 'bgc-error-field': coverField.isMandatory && coverField.errorText!=='' }"
                                @blur="checkError(coverField, coverCode)+addTotalVal(coverField)"
                                v-on:keydown="onlyNumber"
                            />
                        </float-label>
                        <span class="error-text"
                            v-if=" coverField.errorText!==''"
                        >{{ coverField.errorText}}</span> 
                    </div>
                    <div class="form-group p-0 mx-0 my-1" v-if="coverField.dataType=='Date'">
                        <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)">
                        <datepicker
                            format="dd/MM/yyyy"
                            :input-class="isInputError(coverField)"
                            @datePickerBlurred="checkError(coverField,coverCode)"
                            @selected="checkError(coverField, coverCode)"
                            @input="checkError(coverField, coverCode)"
                            :placeholder="coverField.parameterName"
                            v-model="coverField.value">
                        </datepicker>
                        </float-label>
                        <span class="error-text"
                            v-if=" coverField.errorText!==''"
                        >{{ coverField.errorText}}</span> 
                    </div>
                </div>
            </div>
            <p class="multiset-parameter mt-3" v-if="state.coverFieldData.length > 1 && indexParent!==state.coverFieldData.length - 1">{{multisetHeading}} - {{indexParent+2}}</p>
            <hr class="mt-1" v-if="state.coverFieldData.length > 1 && indexParent!==state.coverFieldData.length - 1">
        </div>  
    </div>  
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import imtValidation from '@/imtValidate/imtValidation';
import { reactive, onUpdated, watch, onMounted } from '@vue/composition-api';

export default {
    name: "AddMultiSetCoverField",
    props: ['coverFieldData', 'countPersonList', 'coverCode', 'multisetHeading','startEndorsementSuccess'],
    components: {
        FloatLabel,
        Datepicker
    }, 
    setup(props, context){
        let state = reactive({
            coverFieldData : [],
            applyErrorFlag : false,
            isFirstCall : true
        });
        function checkError(obj, code){  
            if(obj){
                state.applyErrorFlag = false;
                imtValidation.checkError(obj, code)
            }
        }
        function checkMaxLength(obj, code){
            if(obj){
                let parameter = obj.parameterName;
                if(parameter == 'Number of Persons')
                    return 3;
                if(parameter == 'Total Elec. Acc IDV' || parameter == 'Tot Non-Elec. Acc IDV')
                    return 7;
                if(parameter == 'No of Persons' || parameter == 'No. of Persons' || parameter == 'Sum Insured per Trailer' || parameter == 'Trailer Capacity' || parameter == 'Trailer Chassis Number' 
                || parameter == 'Trailer Registration No.' || parameter == 'Total Trailer Value' || parameter == 'Voluntary Excess' || parameter == 'My Policy My Premium Discount'
                || parameter == 'Name of Person' || parameter == 'No of Employees' || parameter == 'No of Drivers' || parameter == 'Rally Period Excess' || parameter == 'Rally Period excess' || parameter == 'No of Trailers'
                || parameter == 'Name' || parameter == 'Sum Insured'){
                    return 20;
                }
                if(parameter == 'Certificate Number' || parameter == 'Nominee Name')
                    return 30;
                if(parameter == 'Rally title and Location from' || parameter=='Rally title and Location to')
                    return 50;
                if(parameter == 'Description')
                    return 100;
            }
        }
        onMounted(()=>{
            context.root.$set(state, 'coverFieldData', props.coverFieldData)
            if(!props.startEndorsementSuccess){
                for(let i=0; i<state.coverFieldData.length; i++){
                    for(let j=0; j <state.coverFieldData[i].length; j++){
                        if(state.coverFieldData[i][j].parameterName == 'Nominee Relation'){
                            context.parent.getDomainList(state.coverFieldData[i][j]);
                        }
                    }
                }
            }
        });
        onUpdated(()=>{
            // if(!state.isFirstCall){
            //     context.parent.resetPlanCardFromAddCoverField();
            // }else{
            //     state.isFirstCall = false;
            // }
            for(let j=0; j < props.coverFieldData.length; j++){
                for(let k=0; k<props.coverFieldData[j].length; k++){
                    if(props.coverFieldData[j][k].parameterName == 'Allocation Percentage'){
                        context.root.$set(props.coverFieldData[j][k], 'value', "100")
                    }
                }
            }
        });
        function isInputError(obj) {
            if( obj.errorText !== '' && obj.isMandatory )
            {
                return 'bgc-input form-control bgc-calendar-icon labelMargin bgc-error-field';
            }
            else{
                return 'bgc-input form-control bgc-calendar-icon labelMargin';
            }
        }
        function addTotalVal(obj){
            if(obj.parameterName == 'Sum Insured per Trailer'){
                let sum = 0;
                for(let j=0; j < props.coverFieldData.length; j++){
                    for(let k=0; k<props.coverFieldData[j].length; k++){
                        if(props.coverFieldData[j][k].parameterName == 'Sum Insured per Trailer'){
                            if(props.coverFieldData[j][k].value)
                                sum = sum + (+props.coverFieldData[j][k].value);
                        }
                    }
                }
                context.parent.addTotalVal(sum);
            }
            // else if(obj.parameterName == 'Allocation Percentage'){
            //     let sum = 0;
            //     for(let j=0; j < props.coverFieldData.length; j++){
            //             for(let k=0; k<props.coverFieldData[j].length; k++){
            //                 if(props.coverFieldData[j][k].parameterName == 'Allocation Percentage'){
            //                 if(props.coverFieldData[j][k].value)
            //                     sum = sum + (+props.coverFieldData[j][k].value);
            //             }
            //         }
            //     }
            //     context.parent.addTotalVal(sum); 
            // }
        }
        function selectDocumentType(countryObj){
            let obj = {};
            for(let i=0; i<countryObj.domainValues.length; i++){
                if(countryObj.domainValues[i].code == countryObj.value){
                    obj = countryObj.domainValues[i];
                    break;
                }
            }
            countryObj.countrySelectedList.push(obj);
            countryObj.value = '';
        }
        function isDocSelected(countryObj, coverField){
            if(Array.isArray(coverField.countrySelectedList)){
                for(let i = 0; i < coverField.countrySelectedList.length; i++) {
                  if(countryObj.code == coverField.countrySelectedList[i].code) {
                    return true;
                  }
                }
                return false;
            }else{
                return false;
            }
        }
        function removeItem(countryObj, coverField){
            let removeArr = [];
            removeArr = coverField.countrySelectedList.filter(element => {
                return element.code !== countryObj.code
            });
            coverField.countrySelectedList = removeArr;
            // if(coverField.countrySelectedList.length == 0){
            //     state.applyErrorFlag = true;
            // }
        }
        const onlyNumber = imtValidation.onlyNumber;
        //const addressOnly = imtValidation.addressOnly;
        const isFloat =  imtValidation.isFloat;
        const validateInput = imtValidation.validateInput;
        watch(()=>[props.countPersonList], ()=>{
            state.coverFieldData = [];
            if(props.coverFieldData && props.coverFieldData.length > 0){
                context.root.$set(state, 'coverFieldData', props.coverFieldData);
                //state.coverFieldData = props.coverFieldData;
                if(!props.startEndorsementSuccess){
                    for(let i=0; i<state.coverFieldData.length; i++){
                        for(let j=0; j <state.coverFieldData[i].length; j++){
                            if(state.coverFieldData[i][j].parameterName == 'Nominee Relation'){
                                context.parent.getDomainList(state.coverFieldData[i][j]);
                            }
                        }
                    }
                }
            }
        });
        return {
            checkError,
            isInputError,
            onlyNumber,
            checkMaxLength,
            addTotalVal,
            selectDocumentType,
            isDocSelected,
            validateInput,
            removeItem,
            isFloat,
            state
        };
    }
}
</script>
<style scoped>
.loader-small img{
  max-width: 35px;
  padding-bottom: 2em;
  position: absolute;
  bottom: 82%;
  right: 52%;
}
.multiset-parameter{
  font-weight: bold;
}
.loader-show-class{
  display: block;
}
.loader-hide-class{
  visibility: hidden;
}
.cover-row{
  margin-left: 3.5em;
  margin-right: 3.5em;
  padding-bottom: 1em;
}
#selectedListCountryType{
  height: 30px;
}
@media (max-width: 1264px) and (min-width: 768px){
   .cover-row{
        margin-left: 2.8em;
        margin-right: 2.8em;
    } 
}    
</style>